import React, { useState, useEffect } from "react";
import axios from "axios";
import BASE_URL from "../../context/AppConfig";

const PayRoll = () => {
  const [attendance, setAttendance] = useState([]);
  const [date, setDate] = useState("");

  useEffect(() => {
    fetchAttendance();
  }, []);

  const fetchAttendance = async () => {
    try {
      const url = date
        ? `${BASE_URL}/payroll-list/?date=${date}`
        : `${BASE_URL}/payroll-list/`;
      
      const response = await axios.get(url);
      setAttendance(response.data);
    } catch (error) {
      console.error("Error fetching attendance:", error);
    }
  };

  return (
    <div className="container mt-4">
      <h3>Pay Roll Records</h3>
      <div className="mb-3">
        <label>Select Date:</label>
        <input
          type="date"
          className="form-control"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
        <button className="btn btn-primary mt-2" onClick={fetchAttendance}>
          Filter
        </button>
      </div>
      <table className="table table-bordered mt-3">
        <thead>
          <tr>
            <th>Worker</th>
            <th>Date</th>
            <th>Check-In</th>
            <th>Check-Out</th>
            <th>Overtime Hours</th>
            <th>Total Wage</th>
          </tr>
        </thead>
        <tbody>
          {attendance.map((att, index) => (
            <tr key={index}>
              <td>{att.worker}</td>
              <td>{att.date}</td>
              <td>{att.check_in || "N/A"}</td>
              <td>{att.check_out || "N/A"}</td>
              <td>{att.overtime_hours || 0}</td>
              <td>₹{att.total_wage}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PayRoll;
